import * as React from "react";

import { UitkLink } from "uitk-react-link";
import { TrackedLink } from "components/utility/analytics/TrackedLink";

import { LinkProps } from "../typings";

const Link = (props: LinkProps) => {
  const { link } = props;
  const { text, url } = link;

  if (!(text && url)) {
    return null;
  }

  return (
    <UitkLink>
      <TrackedLink moduleName="link-juice" href={url} linkName={text}>
        <span className="truncate">{text}</span>
      </TrackedLink>
    </UitkLink>
  );
};

export default Link;
